      
<template>
    <div >
        <div class="main">
            <div class="contentTop">
                <div v-if="type=='1'" class="typeTitle">
                    <img class="icon" src="@/assets/icons/wzf.png" alt="">
                    <span class="type">支付成功</span>
                </div>
                <div v-else-if="type=='2'" class="typeTitle">
                    <img class="icon" src="@/assets/icons/wzf.png" alt="">
                    <span class="type">未支付</span>
                </div>
                <div v-else class="typeTitle">
                    <img class="icon" src="@/assets/icons/guanbi.png" alt="">
                    <span class="type">订单关闭</span>
                </div>
            </div>
            <div class="content">
                <div class="bgWhite pad">
                    <div class="orderNum">订单号：{{info.order_sn}}</div>
                    <div class="lineHeight">提交时间：{{info.create_time | timeType}}</div>
                    <div v-if="type=='1'" class="lineHeight">支付时间：{{info.pay_time | timeType}}</div>
                    <div v-if="type=='3'" class="lineHeight">关闭时间：{{"1591545990" | timeType}}</div>
                </div>
                <div class="title">投保信息</div>
                <div class="bgWhite">
                    <van-cell :title="info.goods_name" />
                    <van-cell title="保障内容"  is-link/>
                    <van-cell title="投保计划" value="1年" />
                    <van-cell value="2020-05-11 00时至2021-05-10 24时">
                        <template #icon>
                           <span>保险期限</span>
                        </template>
                    </van-cell>
                    <van-cell title="投保人" :value="info.user_name" />
                    <van-cell title="被保险人" :value="info.user_name" />
                    <van-cell v-if="type!=2" :title="(type==1 ? '实' : '未') +'付款'" :value="info.pay_permium+'元'" />
                </div>
                <!-- <div  class="pad">
                    <van-cell>
                        <template #title>
                            <span>实付款: <span class="red">￥</span><span class="red price">2300.00</span> </span>
                        </template>
                        <template #right-icon>
                            <van-tag round plain class="tag">查看保单</van-tag>
                        </template>
                    </van-cell>
                </div> -->
            </div>
        </div>
        <!-- <div ></div> -->
        <div class="bottom">
            <van-grid v-if="type==1" column-num="2">
                 <van-grid-item>
                    <van-button class=" btn" round size="large" style="width:90%" color="linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1))">查看保单</van-button>
                </van-grid-item>
                <van-grid-item>
                    <van-button class="btn" round plain size="large" type="danger" style="width:90%">再次购买</van-button>
                </van-grid-item>
            </van-grid>
            <van-grid v-if="type==2" column-num="2">
                <van-grid-item> <p>合计: <span class="red">￥<span class="price">{{info.pay_permium}}</span> </span> </p> </van-grid-item>
                <van-grid-item>
                    <van-button class="btn" round size="large"  style="width:90%" color="linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1))">继续支付</van-button>
                </van-grid-item>
            </van-grid>
            <van-grid v-if="type==3" column-num="1">
                <van-grid-item >
                    <van-button class="btn" round size="large" style="width:80%" color="linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1))">再次购买</van-button>
                </van-grid-item>
            </van-grid>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
           iconList:[""],
           type:"1",   //1支付成功，2未支付，3订单关闭
           info:""
        };
    },
    created(){
        document.title="订单详情";
        this.getDetails();
    },
    methods: {
       onClickButton(){},
        getDetails(){
                this.$https.fetchPost("order/orderDetails",{"order_id":"5"},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    let data=result.data;
                    console.log(data)
                    if(data.code==1){
                       this.info=data.data;
                    }else{
                        Toast(data.msg);
                    }
                })
        }
    },
     filters:{
        timeType(time){
            var date=new Date(time*1000);
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var h=date.getHours();
            var m=date.getMinutes();
            var s=date.getSeconds();
            month= month<10 ? "0"+month : month;
            day= day<10 ? "0"+day : day;
            h= h<10 ? "0"+h : h;
            m= m<10 ? "0"+m : m;
            s= s<10 ? "0"+s : s;
            var nowDate = year + "-" + month + "-" + day+" "+h+ ":" +m+ ":" +s;
            return nowDate
        }
    },
    components:{
        
    },
    computed:{
    },
}
</script>

<style scoped>
    .content{
        text-align: start;
        color: #666;
        padding: 0 12px;
        margin-top: -30px;
        margin-bottom: 70px;
    }
    .contentTop{
        /* position: relative; */
        width: 100%;
        height: 120px;
       background:linear-gradient(-180deg,rgba(243,71,64,1),rgba(251,149,138,1));
        text-align: start;
        line-height: 100px;
    }
    .typeTitle{
        padding-left: 22px;
        display: flex;
        align-items: center;
    }
    .icon{
        width: 22px;
        height: 22px;
            margin-right: 12px;
    }
    .type{
        font-size: 20px;
        color: #fff;
    }
    
    .title{
        font-size: 17px;
        font-weight: bold;
        padding: 25px 12px 10px 12px;
    }
   
    .bgWhite{
        background: #fff;
        border-radius: 6px;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.14);
        padding: 0 12px;
    }
    .pad{
        padding-top: 15px;
        padding-bottom: 15px;
    }
    .orderNum{
        color: #222222;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 5px;
    }
    .lineHeight{
        line-height: 18px;
    }
    .van-cell{
        padding: 13px 0;
    }
    .van-cell__value--alone{
        text-align: right;
    }
    .van-cell,.van-cell__title{
        color:#666;
        font-size: 13px;
    }
      .van-cell__value,.van-cell__value--alone,.title{
        color:#222;
    }
    .price{
        font-size: 18px;
    }
    .tag{
        padding:5px 10px;
    }
    .bottom{
        position: fixed;
        bottom: 0px;
        width: 100%;
        background: #fff;
    }
    .btn{
        height: 45px;    
    }
    .bottom /deep/ .van-grid-item__content{
        padding: 8px;
    }
    .price{
        font-size: 18px;
    }
</style>


// WEBPACK FOOTER //
// src/views/commonPage/myOrderDetails.vue